import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const UPLOAD_ID_DIFFERENT_DATA_LOADING_PROPS = {
    description: '',
    title: '',
  },
  UPLOAD_ID_DIFFERENT_DATA_DESCRIPTION_PROPS = {
    testId: 'upload-id-different-data-description',
  },
  UPLOAD_ID_DIFFERENT_DATA_LINK_PROPS = {
    testId: 'upload-id-different-data-link',
    type: 'PRIMARY_GHOST',
    size: 'LARGE',
  },
  UPLOAD_ID_DIFFERENT_DATA_DETAIL_PROPS = {
    variant: VARIANTS.DetailConfirmationVariantsEnum.ONE_COLUMN_DEFAULT,
  };

export {
  UPLOAD_ID_DIFFERENT_DATA_LOADING_PROPS,
  UPLOAD_ID_DIFFERENT_DATA_DESCRIPTION_PROPS,
  UPLOAD_ID_DIFFERENT_DATA_DETAIL_PROPS,
  UPLOAD_ID_DIFFERENT_DATA_LINK_PROPS,
};
